import React from 'react';

const About = () => {
  return (
    <section id="sobre" className="py-24 bg-[#6B21A8] text-white overflow-hidden relative">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-purple-500 rounded-full blur-[100px] opacity-20 translate-x-1/2 -translate-y-1/2"></div>

      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <span className="text-yellow-400 font-bold uppercase tracking-widest mb-6 block">🌱 O que é o Sora</span>
          <h2 className="font-hero text-4xl md:text-6xl mb-10 leading-[1.1]">
            O Sôra é o seu espaço de apoio para o dia a dia em sala de aula
          </h2>

          <div className="grid md:grid-cols-2 gap-12 text-left">
            <div className="bg-white/10 backdrop-blur-md p-10 rounded-[2.5rem] border border-white/20">
              <p className="text-xl leading-relaxed opacity-90">
                O Sôra é uma plataforma onde professores podem guardar, compartilhar e planejar aulas de forma simples.
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-md p-10 rounded-[2.5rem] border border-white/20">
              <p className="text-xl leading-relaxed opacity-90">
                Aqui, você encontra materiais prontos para impressão, criados por outros professores, e organiza seus próprios conteúdos em um só lugar.
              </p>
            </div>
          </div>

          <div className="mt-20 flex justify-center">
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1524178232363-1fb28f74b671?q=80&w=2070&auto=format&fit=crop"
                alt="Teacher collaborating"
                className="w-full max-w-4xl rounded-[3rem] shadow-2xl border-4 border-white/20"
              />
              <div className="absolute -bottom-6 -right-6 bg-yellow-400 text-black px-8 py-4 rounded-2xl font-display text-xl shadow-xl hidden md:block">
                Feito para Professores
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

